var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.003 7H6a1 1 0 1 1 0 2H3.007l.273.378a.994.994 0 0 1-.16 1.4.994.994 0 0 1-1.4-.16L.22 8.622a1 1 0 0 1 0-1.249l1.5-1.995a.994.994 0 0 1 1.4-.16.994.994 0 0 1 .16 1.4L3.003 7zm-.963 6.337a.5.5 0 0 1 .745-.667 7 7 0 1 0-.005-9.334.5.5 0 0 1-.745-.667 8 8 0 1 1 .006 10.668z"
  })));
};
export default SvgExit;